// extracted by mini-css-extract-plugin
module.exports = {"checkoutFlowLogo":"CheckoutFlowLogo_checkoutFlowLogo__d46zX","cofDesignV1":"CheckoutFlowLogo_cofDesignV1__joUx9"};